/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import clsx from 'clsx';
import { isHeading } from 'datocms-structured-text-utils';
import loadScript from 'load-script2';
import React, { useEffect, useMemo, useRef, useState } from 'react';
// eslint-disable-next-line import/no-unresolved
import { renderNodeRule, StructuredText } from 'react-datocms/structured-text';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useSetAtom } from 'jotai';
import useFindCookie from '../../../../hooks/useCookie';
import useModal from '../../../../hooks/modal';
// import Spinner from '../../../../assets/spinner.inline.svg';

import { buildLink } from '../../../../utils/locale';
import VideoPlayer from '../../molecules/video-player';
import { SocialShareButton } from '../social-share-button';
import { CopyButton } from '../copy-button';
import ModalWrapper from '../../molecules/modal-wrapper';
import { CertificateForm } from '../certificateform/CertificateForm';
import Certificate from '../certificate/Certificate';
import { Button } from '../../../atoms/button';
import { CardList } from '../../molecules/course-list';
import { showModalAtom } from '../../../../../state';
import {
	getBreadcrumbsSeoSchema,
	getImageSeoSchema,
	getOrganizationSeoSchema,
} from '../../../../utils/seo-schema';
import { getBreadcrumLocale, pageTypes } from '../../../../utils/url-helpers';
import { Head } from '../../../templates/head';

const NewGluCourse = ({
	videoEmbed,
	title,
	content,
	category,
	date,
	formattedDate,
	timeStart,
	locale,
	sessions,
	pdfDownload,
	isWebinarCatchUp,
	data,
	location,
}) => {
	const [warning, setWarning] = useState(false);
	const [videoWatched, setVideoWatched] = useState(false);
	const { mainLogo } = data.allDatoCmsGluLogo.nodes[0];
	const metaContent = {
		noIndex: data.datoCmsGluCourse.noIndex,
		noFollow: data.datoCmsGluCourse.noFollow,
		metaInformation: data.datoCmsGluCourse.metaTags,
		fallbackTitle: data.datoCmsGluCourse.eLearningTitle,
		fallbackDescription: '',
		canonicalUrl: data.datoCmsGluCourse?.canonicalUrl || location?.href,
	};

	const seoSchemas = {
		organization: getOrganizationSeoSchema({
			data,
			url: `${location?.origin}/${getBreadcrumLocale(location)}`,
		}),
		breadcrumbs: getBreadcrumbsSeoSchema({
			data: data.datoCmsGluCourse,
			pageType: pageTypes.gluCourse,
			location,
		}),
		image: getImageSeoSchema(mainLogo),
	};

	const [videoFinished, setVideoFinished] = useState();
	const [showFeedbackBubble, setShowFeedbackBubble] = useState();
	const [scriptReady, setScriptReady] = useState(false);
	const { hasCookie, setHasCookie } = useFindCookie({
		name: 'elearningContent',
	});
	const { hasCookie: clearCookies } = useFindCookie({
		name: 'start__c',
	});
	const [consentResponse, setConsentResponse] = React.useState(false);
	const [clearConsent, setClearConsent] = React.useState(false);
	React.useEffect(() => {
		if ((consentResponse && clearConsent) || (hasCookie && clearCookies)) {
			setHasCookie(true);
		}
	}, [clearConsent, consentResponse, hasCookie, clearCookies, setHasCookie]);
	const ref = useRef();
	const { isModalOpen, setModalOpen } = useModal(ref);

	const handleButtonClick = () => {
		if (videoWatched) {
			setModalOpen(true);
			setWarning(false);
		} else {
			setWarning(true);
		}
	};
	useEffect(() => {
		const loadVideoScript = () =>
			loadScript('https://player.vimeo.com/api/player.js')
				.then(() => {
					setScriptReady(true);
				})
				.catch(() => {});

		if (window.requestIdleCallback) {
			window.requestIdleCallback(loadVideoScript);
		} else {
			setTimeout(loadVideoScript);

			setTimeout(() => {
				loadVideoScript();
			}, 100);
		}
	}, []);

	const videosWatchedList = useMemo(() => [], []);

	const showCertificateButton =
		videosWatchedList.includes(videoEmbed?.providerUid) ||
		videoFinished ||
		showFeedbackBubble;
	const [response, setResponse] = useState('');
	const Component = 'div';
	useEffect(() => {
		if ((consentResponse && clearConsent) || hasCookie) {
			window.scrollTo(0, 0); // Scroll to the top of the page
			setModalOpen(false); // Close the modal
		}
	}, [consentResponse, hasCookie, clearConsent, setModalOpen]);
	const setShowModalAtom = useSetAtom(showModalAtom);
	return (
		<GoogleReCaptchaProvider
			reCaptchaKey={process.env.GATSBY_RECAPTCHA_KEY}
		>
			<Head
				metaContent={metaContent}
				seoSchemas={seoSchemas}
				title={title}
			/>
			<section className="bg-white">
				<div className=" bg-white ">
					{isWebinarCatchUp && (
						<p>
							<a
								href={buildLink(locale, '/elearning/webinars')}
								className="underline"
							>
								Webinars
							</a>
							<span className="mx-4">/</span>
							{title}
						</p>
					)}
					<h1 className="text-sm p-2 glusm:text-2xl glumd:text-2xl glulg:text-2xl glu2xl:text-3xl mt-0 font-bold ">
						<span className="bg-brand-red-400/90 p-0 xl:p-2 text-white">
							{title}
						</span>
					</h1>

					<div className="2xl:flex lg:gap-8 2xl:basis-[70%] p-2">
						<div className="lg:basis-[70%] aspect-video relative">
							{(hasCookie && clearCookies) ||
							(consentResponse && clearConsent) ? (
								<div>
									{videoEmbed?.providerUid && (
										<div className="lg:basis-[70%] aspect-video ">
											<VideoPlayer
												videoEmbed={videoEmbed}
												setVideoFinished={
													setVideoFinished
												}
												setVideoWatched={
													setVideoWatched
												}
												setWarning={setWarning}
												setShowFeedbackBubble={
													setShowFeedbackBubble
												}
												scriptReady={scriptReady}
												videosWatchedList={
													videosWatchedList
												}
												locale={locale}
												setIsGlu
											/>
										</div>
									)}
								</div>
							) : (
								<>
									<Component
										className="absolute inset-0 bg-black bg-opacity-80 flex items-center justify-center z-10 overflow-clip cursor-pointer"
										onClick={() =>
											setShowModalAtom((prev) => !prev)
										}
									>
										<Button
											type="button"
											className=" text-black rounded-f"
											aria-label="Play Video"
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												fill="currentColor"
												viewBox="0 0 16 16"
												className="w-8 h-8"
											>
												<path d="M4.5 3.5v9l7-4.5-7-4.5z" />
											</svg>
										</Button>
									</Component>
									<div>
										{videoEmbed?.providerUid && (
											<div className="2xl:basis-[70%] aspect-video ">
												<VideoPlayer
													videoEmbed={videoEmbed}
													setVideoFinished={
														setVideoFinished
													}
													setVideoWatched={
														setVideoWatched
													}
													setWarning={setWarning}
													setShowFeedbackBubble={
														setShowFeedbackBubble
													}
													scriptReady={scriptReady}
													videosWatchedList={
														videosWatchedList
													}
													locale={locale}
													setIsGlu
												/>
											</div>
										)}
									</div>
								</>
							)}
						</div>

						{(hasCookie && clearCookies) ||
						(consentResponse && clearConsent) ? (
							<div className="md:py-10 py-3 shadow-2xl p-5 lg:basis-[30%]">
								{content?.value && (
									<StructuredText
										data={content}
										customNodeRules={[
											renderNodeRule(
												isHeading,
												({ node, children, key }) => {
													const HeadingTag = `h${node.level}`;
													return (
														<HeadingTag
															className="mb-5 text-2xl font-bold lg:text-3xl font-lexend-regular"
															key={key}
														>
															{children}
														</HeadingTag>
													);
												}
											),
										]}
									/>
								)}
								{date && (
									<p className="flex items-center my-6 font-bold text-blue-400">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="18"
											height="17"
											fill="none"
											className="inline-block mr-2"
										>
											<path
												fill="#3954E0"
												d="M16.401 1.812h-2.038v-.549a.587.587 0 0 0-.59-.589.587.587 0 0 0-.588.59v.548h-8.37v-.549a.587.587 0 0 0-.59-.589.587.587 0 0 0-.588.59v.548H1.598A1.6 1.6 0 0 0 0 3.41v11.422a1.6 1.6 0 0 0 1.598 1.598h14.804A1.6 1.6 0 0 0 18 14.832V3.41c0-.878-.717-1.598-1.599-1.598ZM1.598 2.989h2.039v.548c0 .327.262.59.589.59a.587.587 0 0 0 .589-.59V2.99h8.37v.548c0 .327.263.59.59.59a.587.587 0 0 0 .588-.59V2.99h2.039a.42.42 0 0 1 .42.42v1.653H1.177V3.41c0-.23.189-.421.42-.421ZM16.4 15.256H1.598a.42.42 0 0 1-.42-.42V6.239h15.644v8.596a.42.42 0 0 1-.42.421Z"
											/>
										</svg>
										<time>
											Broadcast on: {formattedDate}
										</time>
									</p>
								)}
								<div className="flex flex-col gap-x-3 gap-y-1 sm:flex-row">
									<div className="mt-0">
										{showCertificateButton ? (
											<>
												<button
													type="button"
													onClick={() =>
														handleButtonClick()
													}
													className="hover:[transform:scale(1.1)] hover:[ -webkit-transform: scale(1.1)] hover:[-ms-transform: scale(1.1)] relative z-50 flex items-center bg-blue-400 text-white gap-2 px-3 py-1 transition-all border-2 rounded-md w-max hover:bg-brand-blue-400 hover:text-white"
												>
													Download my certificate
												</button>
												{warning && (
													<>
														<p className="text-brand-red-500">
															Please note: Your
															certificate will be
															available at the end
															of the video
														</p>
													</>
												)}
												<div className="mt-5">
													{pdfDownload?.filename ? (
														<a
															href={
																pdfDownload.url
															}
															target="_blank"
															download={
																pdfDownload.filename
															}
															className="hover:[transform:scale(1.1)] hover:[ -webkit-transform: scale(1.1)] hover:[-ms-transform: scale(1.1)] relative z-10 flex items-center bg-brand-blue-400 text-white gap-2 px-3 py-1 transition-all border-2 rounded-md w-max hover:bg-brand-blue-400 hover:text-white"
															rel="noreferrer"
														>
															<p>
																Click Here To -
																Download slides
															</p>
														</a>
													) : null}
												</div>
											</>
										) : null}
									</div>
								</div>

								{category?.slug !== 'health-and-safety' && (
									<>
										<div className="text-brand-blue-400  items-center text-[20px] py-2">
											<p className="text-base">
												As a client, you can access your
												HR policies here:
											</p>
										</div>
										{locale === 'en-AU' ? (
											<a
												href="https://www.brighthr.com/au/"
												target="_blank"
												rel="noreferrer"
												className="text-blue-400 underline inline-flex items-center text-[20px] gap-5"
											>
												Go to my policies
											</a>
										) : (
											<a
												href="https://app.brighthr.com/document/peninsulaSuppliedDocuments?lvl=1"
												target="_blank"
												rel="noreferrer"
												className="text-blue-400 underline inline-flex items-center text-[20px] gap-5"
											>
												Go to my policies
											</a>
										)}
									</>
								)}

								<SocialShareButton
									text="Love it, Share it"
									hasIcon
									title={title}
								/>
								<CopyButton
									text="Share this answer by copying the link"
									url={
										typeof window !== 'undefined'
											? window.location
											: ''
									}
									className="mt-10 inline-block"
								/>

								{isModalOpen && (
									<ModalWrapper>
										<div
											className="relative m-auto overflow-auto rounded-sm w-7/8 sm:w-3/4 lg:w-1/2 xl:w-1/3 md:mx-0"
											ref={ref}
										>
											<div
												className={clsx(
													'card ',
													response && 'flip'
												)}
											>
												{response === '' ? (
													<CertificateForm
														setResponse={
															setResponse
														}
														pageUrl={
															typeof window !==
															'undefined'
																? window
																		.location
																		.href
																: ''
														}
													/>
												) : (
													<Certificate
														title={title}
														response={response}
													/>
												)}
											</div>
										</div>
									</ModalWrapper>
								)}
							</div>
						) : (
							<div className="shadow-2xl p-5 lg:basis-[30%]">
								{date && (
									<p className="flex items-center my-6 font-bold text-blue-400">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="18"
											height="17"
											fill="none"
											className="inline-block mr-2"
										>
											<path
												fill="#3954E0"
												d="M16.401 1.812h-2.038v-.549a.587.587 0 0 0-.59-.589.587.587 0 0 0-.588.59v.548h-8.37v-.549a.587.587 0 0 0-.59-.589.587.587 0 0 0-.588.59v.548H1.598A1.6 1.6 0 0 0 0 3.41v11.422a1.6 1.6 0 0 0 1.598 1.598h14.804A1.6 1.6 0 0 0 18 14.832V3.41c0-.878-.717-1.598-1.599-1.598ZM1.598 2.989h2.039v.548c0 .327.262.59.589.59a.587.587 0 0 0 .589-.59V2.99h8.37v.548c0 .327.263.59.59.59a.587.587 0 0 0 .588-.59V2.99h2.039a.42.42 0 0 1 .42.42v1.653H1.177V3.41c0-.23.189-.421.42-.421ZM16.4 15.256H1.598a.42.42 0 0 1-.42-.42V6.239h15.644v8.596a.42.42 0 0 1-.42.421Z"
											/>
										</svg>
										<time dateTime={`${date}T${timeStart}`}>
											Broadcast on: {formattedDate}
										</time>
									</p>
								)}
								<h1 className=" text-2xl mb-4 font-bold">
									{title}
								</h1>
								{content?.value && (
									<StructuredText
										data={content}
										customNodeRules={[
											renderNodeRule(
												isHeading,
												({ node, children, key }) => {
													const HeadingTag = `h${node.level}`;
													return (
														<HeadingTag
															className="mb-5 text-2xl font-bold lg:text-3xl font-lexend-regular"
															key={key}
														>
															{children}
														</HeadingTag>
													);
												}
											),
										]}
									/>
								)}
								<div className="text-left mt-5 text-md">
									<p className="text-md ">
										<span className="text-2xl mr-3 text-success-500">
											{' '}
											✓
										</span>
										Enroll in this session for FREE
									</p>
									<p className="text-md ">
										<span className="text-2xl mr-3 text-success-500">
											{' '}
											✓
										</span>
										Unlock hundreds of free training modules
									</p>
									<p className="text-md ">
										<span className="text-2xl mr-3 text-success-500">
											{' '}
											✓
										</span>
										over 44,000+ Members
									</p>
								</div>
								<div className="flex flex-col items-center gap-5 mt-8  w-full lg:flex-row lg:pt-0 shrink-0">
									<Button
										onClick={() =>
											setShowModalAtom((prev) => !prev)
										}
										className="text-center rounded-md !text-sm !block w-full"
										size="Small"
										type="button"
									>
										Access premium content instantly
									</Button>
								</div>
							</div>
						)}
					</div>

					<div className="flex p-3 w-full gap-20 items-center mt-8 overflow-x-scroll carousel-hide-scrollbar">
						<div className="flex gap-7 ">
							<div className="w-12 h-12">
								<img
									src="https://v3assets.digitalmarketinginstitute.com/general/short-courses/Globalmembers_icon.png?mtime=1594810729"
									alt="glu logo"
									className="object-contain object-center"
								/>
							</div>
							<div className="text-left mt-0 text-sm">
								<p>44,000+ Members</p>
							</div>
						</div>
						<div className="flex gap-7 ">
							<div className="w-12 h-12 ">
								<img
									src="https://www.datocms-assets.com/64336/1693834200-cpd.png?auto=format&dpr=0.88&fit=max&w=99"
									alt="glu logo"
									className="object-contain object-center"
								/>
							</div>
							<div className="text-left mt-0 text-sm">
								<p>CPD Certified</p>
							</div>
						</div>
						<div className="flex gap-7 ">
							<div className="w-12 h-12">
								<img
									src="https://www.datocms-assets.com/64336/1693834225-rospa.png?auto=format&fit=max&w=103"
									alt="glu logo"
									className="object-contain object-center"
								/>
							</div>
							<div className="text-left mt-0 text-sm">
								<p>ROSPA Qualifications</p>
							</div>
						</div>
					</div>

					<div>
						{sessions.length > 0 ? (
							<section className="px-4 py-12 w-full">
								<h3 className="mb-5 text-2xl font-bold lg:text-3xl font-lexend-regular">
									More on demand sessions
								</h3>
								<ul
									className={clsx(
										'w-full grid gap-x-20 gap-y-2 sm:gap-y-s-f md:gap-y-base-f grid-flow-row',
										'lg:grid-cols-2 pb-4 sm:pb-5'
									)}
								>
									{sessions?.map((session) => (
										<CardList
											cardContent={session}
											key={session.id}
											locale={locale}
										/>
									))}
								</ul>
							</section>
						) : null}
					</div>
				</div>
			</section>
		</GoogleReCaptchaProvider>
	);
};

export default NewGluCourse;
